import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { authentication } from "./Authentication/reducer";
import { dashboard } from "./Sections/reducer";
import { mesasEntrada } from "./MesasEntrada/reducer";


const rootReducer = combineReducers({
  authentication,  
  dashboard,
  mesasEntrada
});

const composeEnhancers =
  (typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunkMiddleware))
);
